import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilCreateDashboard, UilCircle, UilMoneybag, UilMoneyWithdraw } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getFacilitatorMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'starter',
      label: (
        <NavLink onClick={toggleCollapsed} to={`${basePath}/pages/starter`}>
          {t('SPMU')} {t('Home')}
        </NavLink>
      ),
      icon: !topMenu && (
        <NavLink className="menuItem-iocn" to={`${basePath}/pages/starter`}>
          <UilCircle />
        </NavLink>
      ),
    },
    {
      key: 'projects-menu',
      label: t('Projects'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'active-projects',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/list`}>
              {t('Projects')}
            </NavLink>
          ),
        },
        {
          key: 'assigned-projects',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/assigned`}>
              {t('Assigned Projects')}
            </NavLink>
          ),
        },
        {
          key: 'invested-projects',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/invested`}>
              {t('Invested Projects')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'borrowers-menu',
      label: t('Managers'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'borrowers-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/borrower/list`}>
              {t('Managers List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'investors-menu',
      label: t('Investors'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'investors-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investor/list`}>
              {t('Investors List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'investments-menu',
      label: t('Investments'),
      icon: !topMenu && <UilMoneybag />,
      children: [
        {
          key: 'investments-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investment/list`}>
              {t('Investment List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'disbursements-menu',
      label: t('Disbursements'),
      icon: !topMenu && <UilMoneyWithdraw />,
      children: [
        {
          key: 'disbursements-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/invested`}>
              {t('Disbursable Projects')}
            </NavLink>
          ),
        },
        {
          key: 'investor-disbursements',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/investor/disburse`}>
              {t('Investor Disbursements')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'validations-menu',
      label: t('Validations'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'pending-validation',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/pending`}>
              {t('Pending Validation')}
            </NavLink>
          ),
        },
        {
          key: 'completed-validations',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/completed`}>
              {t('Completed Validations')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'profile-menu',
      label: t('Profile'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'update-profile',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/profile/update/00d02466-425a-45d9-be2c-e36ba1638731`}>
              {t('Update Profile')}
            </NavLink>
          ),
        },
        {
          key: 'view-profile',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/profile/details/00d02466-425a-45d9-be2c-e36ba1638731`}>
              {t('View Profile')}
            </NavLink>
          ),
        },
      ],
    },
  ];
};
